/* Father's Day cutoff: recompute in Pacific/Auckland and correct cached HTML.
   Liquid renders the correct state server side; Shopify may serve that from
   cache, so this re-checks on every page load. The failure mode this exists to
   prevent is a delivery promise outliving its own deadline. */
(function () {
  function nzDateString(d) {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Pacific/Auckland',
      year: 'numeric', month: '2-digit', day: '2-digit'
    }).format(d);
  }

  function toUTC(s) {
    var p = String(s || '').split('-');
    if (p.length !== 3) return NaN;
    return Date.UTC(+p[0], +p[1] - 1, +p[2]);
  }

  function apply(el, today) {
    var cut = toUTC(el.getAttribute('data-cutoff'));
    var evt = toUTC(el.getAttribute('data-event'));
    var rur = toUTC(el.getAttribute('data-rural'));
    if (isNaN(cut) || isNaN(evt)) return;

    if (today > evt) {
      if (el.parentNode) el.parentNode.removeChild(el);
      return;
    }

    var days = Math.round((cut - today) / 86400000);
    var main = el.querySelector('.ws-cutoff__main');
    if (main) {
      if (days > 0) {
        main.textContent = days + (days === 1 ? ' day' : ' days') +
          ' left to order for Father’s Day · order by ' + el.getAttribute('data-label');
      } else if (days === 0) {
        main.textContent = 'Last day to order for Father’s Day';
      } else {
        main.textContent = 'Order now for delivery after Father’s Day';
      }
    }

    var rural = el.querySelector('.ws-cutoff__rural');
    if (rural && (isNaN(rur) || today > rur || days < 0)) {
      if (rural.parentNode) rural.parentNode.removeChild(rural);
    }
  }

  function run() {
    var today = toUTC(nzDateString(new Date()));
    var nodes = document.querySelectorAll('[data-ws-cutoff]');
    for (var i = 0; i < nodes.length; i++) apply(nodes[i], today);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
